import { DateUtils } from "utils/dateutils";
import { MaterialDateConfirmationMilestone } from "../types";

function CompletedTimelineItem({
  milestone
}: {
  milestone: MaterialDateConfirmationMilestone;
}) {
  const displaySourceDate = milestone.actualDate || milestone.projectedDate;
  const displayDate = displaySourceDate
    ? DateUtils.format(displaySourceDate, "MM-DD-YY")
    : "-";

  return (
    <div
      className="timeline-milestone-card w-full lg:max-w-[360px]"
      data-testid={`completed-timeline-item-${milestone.id}`}
    >
      <div className="text-sm text-color-3">
        {milestone.name} on{" "}
        <span className="font-semibold text-color-4">{displayDate}</span>
      </div>
    </div>
  );
}

export default CompletedTimelineItem;
